// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type VitalSourceIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from vital-source.svg
 */
export default function VitalSourceIcon(props: VitalSourceIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="VitalSourceIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M16 0H0v16h16zm-5.055 3.968.085-.014 1.681.28-.16.47c-.452 1.32-.926 2.707-1.422 3.98a82 82 0 0 1-1.978 4.65H7.496a86 86 0 0 1-1.979-4.65A204 204 0 0 1 3.29 2.666l2.026.337.42 1.161c.234.64.47 1.287.585 1.624q.336.986.686 1.968.332.94.685 1.873.315.838.673 1.66.342-.822.658-1.654.356-.931.692-1.872.354-.985.694-1.975c.121-.355.206-.667.29-.977.074-.273.148-.545.247-.844"
          clip-rule="evenodd"
        />
      </g>
    </svg>
  );
}
